import React, { useEffect, useState } from 'react';
import LoaderComponent from '../../components/loader/loader.component';
import GoogleMapsMapComponent from '../../components/google-maps/google-maps-map.component';
import ErrorMessageComponent from '../../components/error-message/error-message.component';
import queryString from "query-string";
import { Buffer } from "buffer";
import GoogleRouteComponent from '../../components/map-marker/google-route.component';
import { MapContainer, TileLayer } from 'react-leaflet';
import { LatLng } from 'leaflet';
import LeafletRouteComponent from '../../components/map-marker/leaflet-route.component';

import ApiService from '../../services/api/api.service';

import ItemUsuario from '../../models/ItemUsuario';
import ItemRuta from '../../models/ItemRuta';
import ItemRutaActuacion from '../../models/ItemRutaActuacion';

import 'leaflet/dist/leaflet.css';

const getGoogleLatLng = (value?: string) : google.maps.LatLngLiteral => {
    if (value) {
        if (value.includes(',')) {
            const valueArray : string[] = value.split(',');
            return {
                lat: parseFloat(valueArray[0]),
                lng: parseFloat(valueArray[1]),
            };
        }
        else {
            const valueArray : string[] = value.split(';');
            return {
                lat: parseFloat(valueArray[0]),
                lng: parseFloat(valueArray[1]),
            };
        }
    }
    else {
        return {
            lat: 0,
            lng: 0,
        };
    }
};

const getLeafletLatLng = (value?: string) : LatLng => {
    if (value) {
        if (value.includes(',')) {
            const valueArray : string[] = value.split(',');
            return new LatLng(parseFloat(valueArray[0]), parseFloat(valueArray[1]));
        }
        else {
            const valueArray : string[] = value.split(';');
            return new LatLng(parseFloat(valueArray[0]), parseFloat(valueArray[1]));
        }
    }
    else {
        return new LatLng(0, 0);
    }
};

interface IRouteReportPageProps {};

interface IRouteReportPageParams {
    IdUsuario: string;
    CodigoCliente: string;
    TokenSesion: string;
    IdRutas: number[];
    Evolucion: boolean;
    EsTemporal: boolean;
    TipoMapa: "OSM" | "MAP";
    Pwd: string;
};

const RouteReportPage = (props: IRouteReportPageProps) : JSX.Element => {
    const [params, setParams] = useState<IRouteReportPageParams>();
    const [user, setUser] = useState<ItemUsuario>();
    const [loading, setLoading] = useState<boolean>(true);
    const [routes, setRoutes] = useState<ItemRuta[]>();
    const [evolution, setEvolution] = useState<boolean>(false);
    const [error, setError] = useState<string>("");

    useEffect(() => {
        let queryParams : queryString.ParsedQuery<string> = queryString.parse(window.location.search);
        setParams(JSON.parse(Buffer.from(queryParams.ItemRuta?.toString() || "", 'base64').toString('ascii')));
    }, []);

    useEffect(() => {
        if (params) {
            let user : ItemUsuario = new ItemUsuario();
            user.IdUsuario = params.IdUsuario;
            user.CodigoCliente = params.CodigoCliente;
            user.Token = params.TokenSesion;
            setUser(user);
            setEvolution(params.Evolucion);
        }
    }, [params]);

    const getRoutes = (Ids: number[], temporary: boolean, user: ItemUsuario, password: string) : Promise<ItemRuta[]> => {
        return new Promise(async (resolve, reject) => {
            let routes: ItemRuta[] = [];
            for (let Id of Ids) {
                let route : ItemRuta | void = await getRoute(Id, temporary, user, password).catch((error: string) => {
                    reject(error);
                });
                if (route) {
                    routes.push(route);
                }
            }
            resolve(routes);
        });
    };
    
    const getRoute = (Id: number, temporary: boolean, user: ItemUsuario, password: string) : Promise<ItemRuta> => {
        return new Promise((resolve, reject) => {
            ApiService.Post<ItemRuta>('Rutas', 'Get', user, {
                "IdRuta": Id,
                "EsTemporal": temporary,
                "Pwd": password,
            }, true, password ? true : false)
                .then((response: ItemRuta) => {
                    response.Actuaciones = response.Actuaciones.filter((actuacion: ItemRutaActuacion) => {
                        return (actuacion.PosicionGPS !== "");
                    });
                    resolve(response);
                }, (error: string) => {
                    reject(error);
                });
        });
    };

    useEffect(() => {
        let intervalId: NodeJS.Timeout | null = null;

        if (user && params) {
            const fetchRoutes = () => {
                setLoading(true);
                setError('');
                getRoutes(params.IdRutas, params.EsTemporal, user, params.Pwd)
                    .then((newRoutes: ItemRuta[]) => {
                        setRoutes(newRoutes);
                        setLoading(false);
                    }, (error: string) => {
                        setError(error);
                        setLoading(false);
                    });
            };

            fetchRoutes();

            intervalId = setInterval(fetchRoutes, 60000);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [user, params]);

    return (
        <div className='d-flex flex-column h-100 w-100'>
            {
                (params && !loading && !error && routes) ? (
                    <div className="row m-0 flex-fill overflow-hidden">
                        <div className="col-12 h-100 overflow-hidden px-2">
                            {
                                params.TipoMapa ? (
                                    (params.TipoMapa === "MAP") ? (
                                        <GoogleMapsMapComponent
                                            zoom={routes.length ? 13 : 3}
                                            center={routes.length ? getGoogleLatLng(routes[0].UltimaPosicionGPS ? 
                                                routes[0].UltimaPosicionGPS : 
                                                routes[0].SalidaPosicionGPS ? 
                                                    routes[0].SalidaPosicionGPS : 
                                                    routes[0].Actuaciones[0].PosicionGPS) : getGoogleLatLng()}>
                                            {
                                                routes.map((route: ItemRuta) => (
                                                    <GoogleRouteComponent
                                                        key={route.Id}
                                                        route={route}
                                                        evolution={evolution} />
                                                ))
                                            }
                                        </GoogleMapsMapComponent>
                                    ) : (params.TipoMapa === "OSM") ? (
                                        <MapContainer 
                                            center={routes.length ? getLeafletLatLng(routes[0].UltimaPosicionGPS ? 
                                                routes[0].UltimaPosicionGPS : 
                                                routes[0].SalidaPosicionGPS ? 
                                                    routes[0].SalidaPosicionGPS : 
                                                    routes[0].Actuaciones[0].PosicionGPS) : getLeafletLatLng()} 
                                            zoom={8}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                minHeight: 400,
                                            }}>
                                            <TileLayer
                                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                            {
                                                routes.map((route: ItemRuta) => (
                                                    <LeafletRouteComponent 
                                                        key={route.Id}
                                                        route={route}
                                                        evolution={evolution}></LeafletRouteComponent>
                                                ))
                                            }
                                        </MapContainer>
                                    ) : (
                                        null
                                    )
                                ) : (
                                    null
                                )
                            }
                        </div>
                    </div>
                ) : (
                    null
                )
            }
            {
                !loading ? (
                    <ErrorMessageComponent message={error} />
                ) : (
                    null
                )
            }
            <LoaderComponent loading={loading} />
        </div>
    );
};

export default RouteReportPage;
